<a
  nz-button
  nzType="link"
  (click)="onExportClick()"
  [disabled]="!isExportEnabled"
  ><ng-content></ng-content
></a>
